import { render, staticRenderFns } from "./kanbanTask.vue?vue&type=template&id=81b3658e&scoped=true&"
import script from "./kanbanTask.vue?vue&type=script&lang=js&"
export * from "./kanbanTask.vue?vue&type=script&lang=js&"
import style0 from "./kanbanTask.vue?vue&type=style&index=0&id=81b3658e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b3658e",
  null
  
)

export default component.exports